import { useContext } from "react";

import { IamAuthContext } from "@megaron/auth-react";
import {
  hasSupportTicketStatusManagerRole,
  isTicketOpenForEdit,
  selectableSupportTicketStatuses,
  type TicketStatus,
} from "@megaron/support-contracts";

export function isSupportTicketEditable(status: TicketStatus): boolean {
  return isTicketOpenForEdit(status);
}

function useMegaraxUserRoles(): readonly string[] | undefined {
  const auth = useContext(IamAuthContext);
  const user = auth.iamUser?.userType === "megarax" ? auth.iamUser : undefined;
  return user?.roles;
}

export function useSupportTicketEditable(status: TicketStatus): boolean {
  return isSupportTicketEditable(status);
}

export function useSelectableSupportTicketStatuses(currentStatus: TicketStatus | string): TicketStatus[] {
  return selectableSupportTicketStatuses(currentStatus, hasSupportTicketStatusManagerRole(useMegaraxUserRoles()));
}
